import Vue from 'vue';
import SpinnerMtech from 'components/spinner-mtech';

let vm;
let visible = true;
let isActive = false;
const staticClass = 'fullscreen column flex-center z-top';

const Loading = {
  show() {
    if (isActive && vm && vm.$forceUpdate) {
      vm.$forceUpdate();
      return;
    }
    isActive = true;
    const node = document.createElement('div');
    document.body.appendChild(node);
    document.body.classList.add('with-loading');

    vm = new Vue({
      name: 'MyLoading',
      el: node,
      render(h) {
        return h(
          'div', {
            staticClass,
          },
          [
            h('transition', {
              props: {
                appear: true,
                name: 'scale-fade',
                mode: 'out-in',
              },
            }, visible ? [
              h(SpinnerMtech, {
                props: {
                  size: 200,
                },
              }),
            ] : []),
          ],
        );
      },
    });
  },
  hide() {
    if (isActive && vm) {
      visible = false;
      vm.$forceUpdate();
      setTimeout(() => {
        if (vm) {
          vm.$destroy();
          document.body.removeChild(vm.$el);
          vm = null;
        }
        document.body.classList.remove('with-loading');
      }, 1000);
    }
  },
};

export default Loading;



// WEBPACK FOOTER //
// ./src/router/loading.js